// #STAFF_CALNAME_V1 (2026-10-21) — Bill: "Calendar not picking Nick Names when listing on Calendar. EX: Jeffrey Thorn coming
// up as Jeffrey T not Jay Thorn." The PM dash already did this (#STAFFOFF_NICKNAME_V1); the Owner dash Staff Calendar, the
// Yard hub Staff Calendar and the RIG Schedule "People Off" row still used the legal first name. One shared helper now.
// Shown as Nickname (first word) + last initial — "Jay T." — else legal first + last initial; unmatched = the old way.
// Names come from 'staff-names' (hrid / first / last / nickname only — no pay), rewritten by App.js every HR save;
// falls back to reading 'hr-employees' if the slim copy is not there yet.
import { useEffect, useState } from 'react';

export const STAFF_NAMES_KEY = 'staff-names';
export const slimStaffNames = (emps) => (Array.isArray(emps) ? emps : [])
  .filter(e => e && (e.first || e.last))
  .map(e => ({ hrid: e.hrid || '', first: e.first || '', last: e.last || '', nickname: e.nickname || '' }));

export const shortNameOf = (nm) => { const p = String(nm || '').trim().split(/\s+/).filter(Boolean); return p.length <= 1 ? (p[0] || '') : `${p[0]} ${p[p.length - 1][0]}.`; };
const rk = (x) => String(x || '').toLowerCase().replace(/[^a-z ]/g, '').replace(/\s+/g, ' ').trim();

// → (entry) => display name. entry = an hr-timeoff row ({ name, hrid }) or a bare name string.
export const makeCalName = (emps) => {
  const byId = {}, byNm = {};
  (emps || []).forEach(h => {
    if (h.hrid) byId[String(h.hrid)] = h;
    const l = (h.last || '').trim(), f = (h.first || '').trim(), n = (h.nickname || '').trim();
    [f && `${f} ${l}`, n && `${n} ${l}`, h.name].filter(Boolean).forEach(k => { const kk = rk(k); if (kk && !byNm[kk]) byNm[kk] = h; });
  });
  return (e) => {
    const name = typeof e === 'string' ? e : (e && e.name);
    const hrid = typeof e === 'string' ? '' : (e && e.hrid);
    const h = (hrid && byId[String(hrid)]) || byNm[rk(name)] || byNm[rk(String(name || '').replace(/\s+(jr|sr|ii|iii|iv)\.?$/i, ''))];
    if (!h) return shortNameOf(name);
    const first = String(h.nickname || h.first || '').trim().split(/\s+/)[0];
    const li = String(h.last || '').trim()[0] || '';
    return first ? (li ? `${first} ${li.toUpperCase()}.` : first) : shortNameOf(name);
  };
};

// Loads the name list once per mount; returns the display-name function (old style until loaded).
export function useCalName(sg) {
  const [fn, setFn] = useState(() => (e) => shortNameOf(typeof e === 'string' ? e : (e && e.name)));
  useEffect(() => {
    let dead = false;
    (async () => {
      let list = null;
      try { const s = await sg(STAFF_NAMES_KEY); if (Array.isArray(s) && s.length) list = s; } catch { /* fall back */ }
      if (!list) { try { const h = await sg('hr-employees'); const a = Array.isArray(h) ? h : (h && Array.isArray(h.rows) ? h.rows : []); if (a.length) list = slimStaffNames(a); } catch { /* none */ } }
      if (!dead && list) { const f = makeCalName(list); setFn(() => f); }
    })();
    return () => { dead = true; };
  }, [sg]);
  return fn;
}
